export class PhoneFinalizeFM {
	confirmedPrivacyPolicy: boolean;
	confirmedToReceiveWorkNotifications: boolean;

	static validate(values: PhoneFinalizeFM) {

		const errors: ValidationErrors = {};

		if (!values.confirmedPrivacyPolicy) {
			errors.confirmedPrivacyPolicy = 'It is required to agree to the privacy policy';
		}

		if (!values.confirmedToReceiveWorkNotifications) {
			errors.confirmedToReceiveWorkNotifications = 'It is required to agree to receiving work notification';
		}

		return errors;
	}
}
